import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { DocumentMenu } from "../shared-components/fhir-sections/documents/document-menu";
import { useDownloadFile } from "./useDownloadFile";

export type DocumentMenuData = {
  id?: string;
  fileName?: string;
  fileType?: string;
  positionX: number;
  positionY: number;
};

export function useDocumentMenu() {
  const { onDownloadFile, isDownloading } = useDownloadFile();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentDocument, setCurrentDocument] = useState<DocumentMenuData | undefined>(undefined);

  function handleDocumentClick(
    docData: Omit<DocumentMenuData, "positionX" | "positionY">,
    event: React.PointerEvent<HTMLElement>
  ) {
    setCurrentDocument({
      ...docData,
      positionX: event.clientX,
      positionY: event.clientY,
    });
    onOpen();
  }

  const documentMenuComponent = (
    <DocumentMenu
      contentType={currentDocument?.fileType}
      docId={currentDocument?.id}
      fileName={currentDocument?.fileName}
      positionX={currentDocument?.positionX}
      positionY={currentDocument?.positionY}
      onDownloadDocument={onDownloadFile}
      isDownloading={isDownloading}
      isOpen={isOpen}
      onClose={onClose}
    />
  );

  return {
    handleDocumentClick,
    documentMenuComponent,
    isDownloading,
    currentDocument,
  };
}
